/**
 * artikelfinder.js — fremde Artikelnummer -> unser Artikel (Aufgabe #58, 23.09.2026).
 *
 * Gehoert zu sections/artikelfinder.liquid. Zwei Einstiege, eine Maschine:
 *   A) eine Nummer im Suchfeld            -> /api/b2b/finder/suggest
 *   B) eine ganze Liste (Datei/Einfuegen) -> /api/b2b/import/parse + /finder/resolve
 *      danach optional                    -> /api/b2b/finder/auswertung
 *   Nummern ohne Zuordnung                -> /api/b2b/finder/anfrage
 *
 * ⚠️⚠️ DIE DATEI WIRD VOM BESTEHENDEN IMPORT-ENDPUNKT GELESEN, nicht hier. Es gibt
 * bewusst keinen zweiten Parser: /api/b2b/import/parse liefert ROHE Zellen, die
 * Spaltenzuordnung entscheidet der Browser. Dadurch braucht eine Korrektur keine
 * zweite Runde und keinen zweiten Codepfad (siehe ImportController-Kopf).
 *
 * ⚠️⚠️ apiBase ist pim.schaltschrank24.ch, NICHT die Shop-Domain. Ein Aufruf gegen
 * die eigene Domain landet bei Shopify und ergibt einen Shopify-404 — der Fehler
 * sieht aus wie „Endpunkt kaputt", ist aber nur der falsche Host.
 *
 * ⚠️ Wortlaut: „noch keine Zuordnung", NIE „nicht im Sortiment". Nur 42.5 % unseres
 * Katalogs sind ueber eine fremde Nummer auffindbar; die fehlende Zuordnung ist damit
 * der haeufigste Fall, und der Artikel fehlt dabei fast nie — nur seine Nummer.
 *
 * ⚠️ Preise kommen als RAPPEN (`pack`), wie ueberall im Theme. window.SU.money()
 * erwartet Franken — also /100, und zwar genau einmal.
 */
(function () {
  'use strict';

  var wurzel = document.getElementById('af');
  if (!wurzel) { return; }

  /**
   * Stand dieser Datei.
   *
   * ⚠️ Nicht Zierde, sondern Diagnose. Am 24.09.2026 ging ein halber Tag dafuer
   * drauf, zu klaeren, ob eine gemeldete Fehlfunktion noch im Code steckt oder
   * ob schlicht die alte Fassung ausgeliefert wurde — das Live-Theme trug
   * 34'106 B, waehrend lokal 53'033 B fertig lagen. Mit dieser Zeile beantwortet
   * ein Blick in die Browser-Konsole die Frage in einer Sekunde.
   */
  var STAND = '2026-09-24 Gesamt fuer N Bestellungen, pro Bestellung klein';
  if (window.console) { console.info('[Artikelfinder] Stand: ' + STAND); }

  var cfg = window.b2bConfig || {};
  var BASIS = cfg.apiBase || 'https://pim.schaltschrank24.ch';
  var KEY = cfg.apiKey || '';

  // ⚠️ Ohne Schluessel antwortet die API mit 401, und der Nutzer sieht nur
  // „Die Suche ist gerade nicht erreichbar." — eine Meldung ueber das Netz,
  // obwohl die Ursache im Theme liegt. Am 23.09.2026 hat genau das die Suche
  // an der falschen Stelle suchen lassen. Die echte Diagnose gehoert in die
  // Konsole, sonst wiederholt sich der Umweg.
  if (!KEY && window.console) {
    console.error('[Artikelfinder] window.b2bConfig fehlt oder hat keinen apiKey. ' +
      'Haeufigste Ursache: Das Skript-Tag traegt kein defer und startet vor dem ' +
      'b2bConfig-Block in theme.liquid.');
  }

  /** Hoechstens so viele Zeilen — gleicher Deckel wie serverseitig. */
  var MAX_ZEILEN = 500;

  /** Ab so vielen Zeichen sucht das Feld. Darunter lohnt sich keine Abfrage. */
  var MIN_ZEICHEN = 3;

  // Zustand der Listen-Auswertung.
  var zellen = [];        // rohe Zeilen aus /import/parse
  var zuordnung = {};     // Spaltenindex -> 'nr' | 'preis' | 'menge' | ''
  var aufgeloest = [];    // Antwort von /finder/resolve
  var wahl = {};          // Zeilenindex -> gewaehlte SKU (bei Mehrdeutigkeit)
  var letzteAnfrage = null; // die zuletzt gerechnete Auswertung, fuer das PDF

  /**
   * Varianten-ID -> Trefferkarte, fuer das Ergebnis mehrerer Nummern.
   *
   * ⚠️ Die Favoriten brauchen mehr als die ID: sku, handle, Titel, Bild, Kategorie.
   * Alles davon aus data-Attributen im DOM zurueckzulesen waere moeglich, aber dann
   * stuende jede Artikelbezeichnung doppelt im Markup — einmal sichtbar, einmal als
   * Attribut. Hier steht sie einmal, und das DOM traegt nur die ID.
   */
  var karten = {};

  // ── Kleinkram ───────────────────────────────────────────────────────────

  function el(id) { return document.getElementById(id); }

  /** ⚠️ Jede Einsetzung in den DOM geht hierdurch. Die Daten stammen zwar aus unserer
   *  eigenen API, aber sie enthalten Artikelbezeichnungen und — schlimmer — die
   *  Eingabe des Kunden. Ein `<img onerror>` in einer Artikelnummer waere sonst ein
   *  Einfallstor auf jeder Seite, die diese Nummer spaeter anzeigt. */
  function sicher(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function geld(rappen) {
    var chf = (parseInt(rappen, 10) || 0) / 100;
    return window.SU && window.SU.money ? window.SU.money(chf) : chf.toFixed(2);
  }

  /** Einheitspreise unter einem Franken brauchen vier Stellen — eine Aderendhuelse
   *  kostet 0.0344. Mit drei Stellen liesse sich die ausgewiesene Ersparnis aus den
   *  angezeigten Zahlen nicht nachrechnen, und genau das tut ein Kunde, der ueberlegt
   *  zu wechseln. Gleiche Regel wie serverseitig in SavingsCalculator::stellenFuer(). */
  function einheitspreis(chf) {
    var n = parseFloat(chf);
    if (!isFinite(n)) { return ''; }
    return n.toFixed(Math.abs(n) < 1 ? 4 : 3);
  }

  function zeigen(name) {
    ['ablegen', 'spalten', 'pruefen', 'auswertung'].forEach(function (s) {
      var k = el('af-schritt-' + s);
      if (k) { k.hidden = (s !== name); }
    });
    // ⭐ In der Auswertung steht NUR die Auswertung (seit 24.09.2026). Suchfeld,
    // Leerzustand und Listen-Einstieg darueber lenkten ab und schoben das
    // Ergebnis unter den Rand. Ausgeblendet per Klasse, siehe .af-nur-auswertung.
    wurzel.classList.toggle('af-nur-auswertung', name === 'auswertung');
    wurzel.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function fehler(text) {
    el('af-fehler').innerHTML = '<div class="af-band warn">' + sicher(text) + '</div>';
  }

  function fehlerWeg() { el('af-fehler').innerHTML = ''; }

  /**
   * Aufruf der B2B-API.
   *
   * ⚠️ Ein Netzfehler darf nie als leeres Ergebnis durchgehen — sonst sieht der Kunde
   * „nichts gefunden", obwohl wir nur nicht gefragt haben. Deshalb wirft die Funktion
   * und die Aufrufer fangen sichtbar.
   */
  function api(pfad, daten) {
    return fetch(BASIS + pfad, {
      method: 'POST',
      headers: { 'X-Api-Key': KEY, 'Content-Type': 'application/x-www-form-urlencoded' },
      body: koerperAus(daten)
    }).then(function (r) {
      if (!r.ok) {
        // ⚠️ Den Status AM Fehler mitgeben. Nur im Text steht er fuer eine
        // Fallunterscheidung nicht zur Verfuegung — und genau die braucht
        // fehlerText(): 401 ist etwas anderes als 429.
        var e = new Error('Antwort ' + r.status);
        e.status = r.status;
        throw e;
      }
      return r.json();
    });
  }

  /**
   * Der Anfragekoerper — EINE Stelle fuer JSON-Aufrufe und den PDF-Download.
   *
   * ⚠️ Herausgeloest am 24.09.2026, als der PDF-Download dazukam. Eine zweite
   * Kopie dieser Regeln haette den Fehler unten ein zweites Mal ermoeglicht.
   */
  function koerperAus(daten) {
    var koerper = new URLSearchParams();

    Object.keys(daten || {}).forEach(function (k) {
      var v = daten[k];

      // ⚠️⚠️ HIER LAG DER FEHLER (24.09.2026). Bis dahin stand oben ein
      // Array.isArray-Zweig, der JEDES Element flach als `k[]` anhaengte:
      //
      //   if (Array.isArray(v)) { v.forEach(function (x) { koerper.append(k + '[]', x); }); }
      //
      // Fuer `nummern: ['24092','60102']` war das richtig. Fuer
      // `zeilen: [{i:0, nr:'24092'}, …]` war es fatal: URLSearchParams macht aus
      // einem Objekt die Zeichenkette "[object Object]". Der Server empfing drei
      // Zeilen ohne `nr`, der Resolver las '' und antwortete brav mit dreimal
      // „keine Zuordnung" — bei Nummern, die er sicher kennt.
      //
      // Der verschachtelte Zweig darunter war korrekt, wurde aber NIE erreicht:
      // Array.isArray() greift vorher, und ein Array ist eben auch ein Objekt.
      //
      // ⚠️ Betroffen waren ALLE drei Sammelwege — Mehrfachsuche, Listenweg und
      // die Ersparnisrechnung (`positionen`). Nur die Einzelsuche ging, weil sie
      // mit `nr: '24092'` einen schlichten String schickt.
      if (Array.isArray(v)) {
        v.forEach(function (x, i) {
          if (x !== null && typeof x === 'object') {
            // zeilen[0][nr]=24092 — die Form, die Symfony wieder als Array liest.
            Object.keys(x).forEach(function (f) {
              koerper.append(k + '[' + i + '][' + f + ']', x[f]);
            });
          } else if (x !== undefined && x !== null) {
            // nummern[]=24092 — flache Liste, unveraendert.
            koerper.append(k + '[]', x);
          }
        });
      } else if (v !== null && typeof v === 'object') {
        Object.keys(v).forEach(function (i) {
          Object.keys(v[i]).forEach(function (f) { koerper.append(k + '[' + i + '][' + f + ']', v[i][f]); });
        });
      } else if (v !== undefined && v !== null) {
        koerper.append(k, v);
      }
    });

    return koerper;
  }

  /**
   * Die zuletzt gezeigte Auswertung als PDF herunterladen.
   *
   * ⚠️ Der Server rechnet NEU, mit genau der gemerkten Anfrage (letzteAnfrage) —
   * es wird nichts vom Bildschirm abgeschrieben. Das PDF entsteht im Speicher und
   * wird nirgends abgelegt; die Preise des Kunden bleiben ungespeichert.
   *
   * ⚠️ Geprueft wird der Content-Type: Liefert der Server statt des PDFs JSON (etwa
   * bei leerer Liste), darf daraus keine kaputte „.pdf" werden.
   */
  function pdfLaden(knopf) {
    if (!letzteAnfrage) { return; }
    var alt = knopfLaeuft(knopf, 'PDF wird erstellt …');

    var daten = {};
    Object.keys(letzteAnfrage).forEach(function (k) { daten[k] = letzteAnfrage[k]; });
    daten.format = 'pdf';

    fetch(BASIS + '/api/b2b/finder/auswertung', {
      method: 'POST',
      headers: { 'X-Api-Key': KEY, 'Content-Type': 'application/x-www-form-urlencoded' },
      body: koerperAus(daten)
    }).then(function (r) {
      if (!r.ok) {
        var e = new Error('Antwort ' + r.status);
        e.status = r.status;
        throw e;
      }
      if ((r.headers.get('Content-Type') || '').indexOf('application/pdf') !== 0) {
        throw new Error('kein PDF');
      }
      return r.blob();
    }).then(function (blob) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      var d = new Date();
      a.href = url;
      a.download = 'artikelfinder-auswertung-' + d.getFullYear() + '-'
        + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + '.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      // ⚠️ Erst spaeter freigeben: Manche Browser lesen die Adresse erst nach dem Klick.
      setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
      knopfFertig(knopf, alt, '✓ heruntergeladen', false);
    }).catch(function (e) {
      knopfZurueck(knopf, alt);
      fehler(fehlerText(e, 'Das PDF'));
      if (window.console) { console.warn('[Artikelfinder] PDF', e); }
    });
  }

  /**
   * Fehlertext aus dem HTTP-Status.
   *
   * ⚠️⚠️ „Ist gerade nicht erreichbar" fuer ALLES war am 23.09.2026 der Grund,
   * warum ein 401 tagelang fuer ein Netz- oder Serverproblem gehalten wurde. Die
   * Meldung deutete auf die eine Ursache, die es nicht war, und die Suche lief in
   * die falsche Richtung.
   *
   * ⚠️ Der Status gehoert deshalb IN die Anzeige — nicht nur in die Konsole.
   * Ein Kunde meldet „Status 401", und damit ist der Fall in Sekunden klar.
   * Ohne Status meldet er „geht nicht", und es beginnt von vorn.
   */
  function fehlerText(e, was) {
    var s = e && e.status;

    if (s === 401 || s === 403) {
      return was + ' ist für dein Konto nicht freigeschaltet (Status ' + s + '). Bitte melde dich kurz bei uns.';
    }
    // ⚠️ Die serverseitige Bremse zaehlt ZEILEN je IP — ein ganzes Buero teilt
    // sich oft eine. „Zu viele Anfragen" waere hier irrefuehrend.
    if (s === 429) {
      return 'Es kamen zu viele Zeilen in kurzer Zeit. Bitte in ein paar Minuten erneut versuchen.';
    }
    if (s) {
      return was + ' antwortet nicht (Status ' + s + '). Bitte melde dich kurz bei uns.';
    }

    // Kein Status: Die Antwort kam gar nicht an — Netz, CORS oder abgebrochen.
    return was + ' ist gerade nicht erreichbar. Bitte in einem Moment erneut versuchen.';
  }

  // ── Einstieg A: eine Nummer ─────────────────────────────────────────────

  var suchZeit = null;

  /**
   * Zerlegt die Eingabe in einzelne Nummern.
   *
   * ⚠️ Getrennt wird an Komma, Semikolon, Zeilenumbruch und Tabulator — nicht am
   * Leerzeichen. Unsere eigenen Nummern enthalten keines, fremde Bezeichnungen
   * aber sehr wohl („Gewindeplaettchen M6"), und die Suche ueber den Text ist ein
   * gleichberechtigter Weg. Am Leerzeichen zu trennen wuerde ihn unbrauchbar
   * machen.
   *
   * ⚠️ Wer aus Excel eine Spalte kopiert, bekommt Zeilenumbrueche — die gehoeren
   * deshalb dazu, auch wenn der Hilfetext nur das Komma nennt.
   */
  function nummernAusText(text) {
    return String(text || '').split(/[,;\n\r\t]+/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return s.length > 0; });
  }

  el('af-suche').addEventListener('input', function () {
    var wert = this.value.trim();
    clearTimeout(suchZeit);

    // ⚠️ Der Leerzustand-Hinweis verschwindet beim ersten Zeichen und kommt nicht
    // zurueck. Er erklaert, was zu tun ist — wer schon tippt, weiss es bereits, und
    // ein Hinweis der bleibt waehrend Treffer erscheinen, stiftet nur Unruhe.
    var leer = el('af-leer');
    if (leer) { leer.hidden = wert.length > 0; }

    // ⚠️⚠️ Mehrere Nummern: NICHT automatisch suchen. Waehrend jemand
    // „24092, 22423, 44142" tippt, entstuenden sonst bei jedem Komma eine
    // Sammelanfrage und drei verworfene Antworten. Stattdessen ein Knopf —
    // der Kunde entscheidet, wann er fertig getippt hat.
    var viele = nummernAusText(wert);
    var kasten = el('af-mehrfach');

    if (viele.length >= 2) {
      if (kasten) {
        el('af-mehrfach-zahl').textContent = String(viele.length);
        kasten.hidden = false;
      }
      el('af-treffer').innerHTML = '';
      el('af-laeuft').hidden = true;

      return;
    }

    if (kasten) { kasten.hidden = true; }

    if (wert.length < MIN_ZEICHEN) {
      el('af-treffer').innerHTML = '';
      el('af-laeuft').hidden = true;
      return;
    }

    // ⚠️ Entprellt: das Feld sucht bei jedem Tastendruck, und jede Anfrage zaehlt auf
    // die serverseitige Zeilenbremse. 300 ms sind kurz genug, dass es sofort wirkt.
    el('af-laeuft').hidden = false;
    suchZeit = setTimeout(function () { sucheEine(wert); }, 300);
  });

  /**
   * Mehrere Nummern auf einmal.
   *
   * ⚠️ Dieselbe ROUTE wie der Listeneinstieg (/finder/resolve, Format {i, nr}) —
   * aber eine EIGENE Anzeige.
   *
   * ⚠️⚠️ Bis zum 24.09.2026 lief das hier auf pruefenZeigen(), also auf die
   * Anzeige des Listenwegs. Das war falsch, und zwar sichtbar falsch: Jene
   * Anzeige ist fuer eine Excel mit 200 Zeilen gebaut. Sie steckt die Treffer in
   * ein ZUGEKLAPPTES <details> ohne Bild, ohne Preis und ohne Korbknopf,
   * waehrend der Kasten „Zeilen ohne Zuordnung" mit `open` aufgeht. Wer drei
   * Nummern eintippt und zwei davon findet, bekam deshalb als Erstes und
   * Einziges den Satz „Zu diesen Nummern haben wir noch keine Zuordnung" zu
   * sehen — das Gegenteil des Ergebnisses.
   *
   * Hier gilt: gefundene Artikel als Karten untereinander, auswaehlbar, mit
   * Menge, und ein Knopf legt alle Ausgewaehlten gemeinsam in den Warenkorb.
   *
   * ⚠️ Ohne Preise und Mengen aus einer Datei. Wer Nummern ins Suchfeld tippt,
   * will wissen was passt; die Ersparnisrechnung braucht eine Liste mit Preisen
   * und steht weiterhin hinter dem Listenweg.
   */
  var mehrfachKnopf = el('af-mehrfach-los');
  if (mehrfachKnopf) {
    mehrfachKnopf.addEventListener('click', function () {
      var nummern = nummernAusText(el('af-suche').value);
      if (nummern.length < 2) { return; }

      if (nummern.length > MAX_ZEILEN) {
        fehler('Das sind ' + nummern.length + ' Nummern. Bis ' + MAX_ZEILEN
          + ' gehen auf einmal — für mehr bitte die Liste hochladen.');
        return;
      }

      fehlerWeg();
      this.disabled = true;
      var knopf = this;

      api('/api/b2b/finder/resolve', {
        zeilen: nummern.map(function (nr, i) { return { i: i, nr: nr }; })
      }).then(function (a) {
        knopf.disabled = false;
        aufgeloest = a.zeilen || [];

        // ⚠️⚠️ EIGENES try/catch, und zwar mit Absicht. Stuende mehrfachZeigen()
        // nackt im .then, landete JEDER Fehler der Anzeige im .catch unten — und
        // der macht daraus „Die Prüfung ist gerade nicht erreichbar". Ein
        // Tippfehler im Markup saehe dann aus wie ein Netzproblem und schickte
        // die Suche tagelang in die falsche Richtung. Genau dieser Umweg ist am
        // 23.09.2026 schon einmal passiert (siehe Kopf von sections/artikelfinder.liquid).
        try {
          mehrfachZeigen();
        } catch (fehlerBeimZeigen) {
          fehler('Die Treffer konnten nicht angezeigt werden — bitte melde uns das. '
            + 'Die Einzelsuche funktioniert weiterhin.');
          if (window.console) {
            console.error('[Artikelfinder] mehrfachZeigen() ist gescheitert:', fehlerBeimZeigen);
          }
        }
      }).catch(function (e) {
        knopf.disabled = false;
        fehler(fehlerText(e, 'Die Prüfung'));
        if (window.console) { console.warn('[Artikelfinder]', e); }
      });
    });
  }

  /**
   * Ergebnis mehrerer Nummern: eine Zeile je Artikel, auswaehlbar, ein Korb.
   *
   * ⚠️⚠️ ZEILEN, KEINE KARTEN (seit 24.09.2026). Die Karten mit 76-px-Bild und
   * eigener Zuordnungszeile brauchten je Treffer rund 150 px — bei 40 Nummern
   * ein Ergebnis von sechs Bildschirmhoehen, in dem niemand mehr vergleicht.
   * Die Zeile traegt dieselben Angaben (Nummer, Artikel, Abweichung, Pack- und
   * Stueckpreis) in einem Viertel der Hoehe, und die Spalten stehen untereinander.
   *
   * Reihenfolge ist Absicht — was der Kunde brauchen kann, steht oben:
   *   1. eindeutig gefunden   (vorausgewaehlt)
   *   2. mehrdeutig           (NICHT vorausgewaehlt, er muss entscheiden)
   *   3. ohne Zuordnung       (zuletzt, kompakt, mit Anfrage-Knopf)
   *
   * ⚠️ Geschrieben wird nach #af-treffer, also an dieselbe Stelle wie das
   * Ergebnis der Einzelsuche. Kein Wechsel auf einen anderen Schritt: Wer im
   * Suchfeld tippt, soll seine Eingabe behalten und sie korrigieren koennen.
   */
  function mehrfachZeigen() {
    var ok = aufgeloest.filter(function (z) { return z.status === 'ok'; });
    var mehrdeutig = aufgeloest.filter(function (z) { return z.status === 'mehrdeutig'; });
    var ohne = aufgeloest.filter(function (z) {
      return z.status === 'keine_zuordnung' || z.status === 'nicht_verfuegbar';
    });

    // ⚠️ Bei jedem Lauf neu. Bliebe der Speicher stehen, legte der Sammelknopf
    // Artikel aus einer frueheren Suche mit in den Korb, die gar nicht mehr am
    // Bildschirm stehen.
    karten = {};
    aufgeloest.forEach(function (z) {
      (z.treffer || []).forEach(function (t) { karten[t.id] = t; });
    });

    var gefunden = ok.length + mehrdeutig.length;
    var html = '<div class="af-bilanz"><b>' + aufgeloest.length + ' Nummern geprüft</b>'
      + '<span>' + gefunden + ' gefunden'
      + (ohne.length ? ' · ' + ohne.length + ' ohne Zuordnung' : '') + '</span></div>';

    if (gefunden) {
      html += '<div class="af-zeilen">' + kopfHtml(true, !mehrdeutig.length);

      // ── 1. Eindeutig ──────────────────────────────────────────────────────
      ok.forEach(function (z) {
        var t = (z.treffer || [])[0];
        if (!t) { return; }
        html += zeileHtml(t, { nr: z.eingabe, an: true });
      });

      // ── 2. Mehrdeutig ─────────────────────────────────────────────────────
      // Die Nummer steht nur in der ersten Zeile der Gruppe; der gelbe Rand
      // haelt die Gruppe zusammen, bis der Kunde eine Zeile ankreuzt.
      mehrdeutig.forEach(function (z) {
        var liste = z.treffer || [];
        html += '<div class="af-zeile-hinweis">Zu <b>' + sicher(z.eingabe) + '</b> passen '
          + liste.length + ' Artikel — bitte den richtigen ankreuzen.</div>';
        liste.forEach(function (t, n) {
          html += zeileHtml(t, { nr: n === 0 ? z.eingabe : '', an: false, offen: true });
        });
      });

      html += '</div>';
    }

    // ⭐ Wer Nummern tippt, hat seine Preise meist in einer Liste. Der Weg dahin
    // soll hier stehen, nicht nur zugeklappt unten auf der Seite.
    if (gefunden) {
      html += '<p class="af-hilfe">Du möchtest mit deinen Einkaufspreisen vergleichen? '
        + '<button type="button" class="af-link" data-af-liste-oeffnen="1">'
        + 'Liste mit Preis und Bedarf prüfen →</button></p>';
    }

    // ── 3. Ohne Zuordnung ───────────────────────────────────────────────────
    if (ohne.length) {
      html += '<div class="af-band info" style="margin-top:26px">'
        + '<b>' + ohne.length + (ohne.length === 1 ? ' Nummer' : ' Nummern')
        + ' konnten wir nicht zuordnen:</b> '
        + ohne.map(function (z) { return sicher(z.eingabe); }).join(', ') + '<br>'
        + 'Das heisst nicht, dass wir die Artikel nicht führen — wir kennen nur diese '
        + 'Nummern noch nicht. Schick sie uns, wir prüfen sie von Hand.'
        + '<div style="margin-top:11px"><button type="button" class="af-knopf leer klein" '
        + 'data-af-anfrage-alle="1">Prüfen lassen</button></div></div>';
    }

    // ── Sammelknopf ─────────────────────────────────────────────────────────
    // ⚠️ Nur wenn es ueberhaupt etwas zu legen gibt. Ein Knopf, der auf eine leere
    // Auswahl zeigt, sieht nach Fehler aus, wo keiner ist.
    // ⚠️ „Alle auswählen" steht seit dem Umbau im Kopf der Liste, ueber der
    // Spalte der Kaestchen — dort, wo man ihn bei einer Tabelle sucht.
    if (gefunden) {
      html += '<div class="af-sammel">'
        + '<span class="af-sammel-zahl" data-af-zaehler>0 ausgewählt</span>'
        // ⭐ Merken kommt vor Kaufen. Wer zwanzig Nummern prueft, vergleicht meist
        // erst — und braucht dann eine Liste, keinen Warenkorb.
        // ⚠️ „Auswahl …" im Text: Neben den Knoepfen je Zeile muss klar sein,
        // dass diese beiden fuer alles Angekreuzte gelten.
        + '<button type="button" class="af-knopf leer klein" data-af-fav-wahl="1">'
        + 'Auswahl merken</button>'
        + '<button type="button" class="af-knopf rot klein" data-af-korb-wahl="1">'
        + 'Auswahl in den Warenkorb</button></div>';
    }

    el('af-treffer').innerHTML = html;
    el('af-laeuft').hidden = true;
    zaehlerAktualisieren();
  }

  /**
   * Was ist gerade angekreuzt?
   *
   * ⚠️ Nach Varianten-ID zusammengefasst. Wer „24092, 24092" eintippt — oder zwei
   * fremde Nummern erwischt, die auf denselben Artikel zeigen —, bekaeme sonst zwei
   * Posten mit derselben ID; der Warenkorb nimmt beide an und zeigt eine Menge, die
   * niemand so eingestellt hat.
   *
   * @return array<{id, menge, karte}>
   */
  function gewaehlte() {
    var gesehen = {};
    var raus = [];

    wurzel.querySelectorAll('input[data-af-wahl]:checked').forEach(function (k) {
      var id = k.getAttribute('data-af-wahl');
      var menge = mengeIn(k.closest('.af-zeile'));

      if (gesehen[id] === undefined) {
        gesehen[id] = raus.length;
        raus.push({ id: id, menge: menge, karte: karten[id] || null });
      } else {
        raus[gesehen[id]].menge += menge;
      }
    });

    return raus;
  }

  /** Menge aus dem Feld einer Trefferzeile; leer oder unsinnig zaehlt als 1. */
  function mengeIn(zeile) {
    var feld = zeile && zeile.querySelector('input[data-af-menge]');
    return Math.max(1, parseInt(feld && feld.value, 10) || 1);
  }

  /** Zeigt an, worauf die beiden Sammelknoepfe gerade zeigen. */
  function zaehlerAktualisieren() {
    var feld = wurzel.querySelector('[data-af-zaehler]');
    if (!feld) { return; }
    var n = wurzel.querySelectorAll('input[data-af-wahl]:checked').length;
    feld.textContent = n === 1 ? '1 ausgewählt' : n + ' ausgewählt';
  }

  function sucheEine(nr) {
    api('/api/b2b/finder/suggest', { nr: nr }).then(function (a) {
      el('af-laeuft').hidden = true;
      var z = (a.zeilen || [])[0];
      if (!z) { el('af-treffer').innerHTML = ''; return; }

      // ⚠️ Auch hier den Kartenspeicher fuellen: Der Favoritenknopf je Zeile
      // braucht sku, handle, Titel und Bild — nicht nur die ID aus dem DOM.
      karten = {};
      (z.treffer || []).concat(a.vorschlaege || []).forEach(function (t) { karten[t.id] = t; });

      el('af-treffer').innerHTML = trefferHtml(z) + vorschlaegeHtml(a.vorschlaege || []);
    }).catch(function (e) {
      el('af-laeuft').hidden = true;
      fehler(fehlerText(e, 'Die Suche'));
      if (window.console) { console.warn('[Artikelfinder]', e); }
    });
  }

  function trefferHtml(z) {
    var aus = '';

    // ⚠️ KEIN blaues Band. Die Markenerkennung ist der erste Eindruck nach einer
    // Eingabe und stand bis zum 24.09.2026 in einem blauen Hinweiskasten — eine
    // Farbe, die im Erscheinungsbild des Shops nicht vorkommt und das Werkzeug
    // wie eingeklebt wirken liess. Jetzt eine schmale Zeile in Hausfarben, mit
    // der erkannten Nummer als rotem Akzent.
    // ⚠️⚠️ DER NAME DES MITBEWERBERS WIRD NIE GENANNT. Hier stand bis zum
    // 24.09.2026 der Markenname im Klartext. Das ist aus drei Gruenden falsch:
    // Es wirbt fuer die Gegenseite, es legt offen woher unsere Zuordnungen
    // stammen, und es verengt das Werkzeug auf eine Marke — sobald weitere
    // Quellen dazukommen, muesste an jeder Stelle nachgezogen werden.
    //
    // ⚠️ Auch in diesem Kommentar nicht. Skript-Kommentare werden mit
    // ausgeliefert und sind im Quelltext jeder Shop-Seite lesbar.
    //
    // ⚠️ `z.marke` kommt weiterhin vom Server und steht in der Datenbank. Das
    // ist richtig so: intern muss nachvollziehbar bleiben, woher eine Zuordnung
    // stammt. Nur der Kunde sieht es nicht.
    if (z.marke) {
      aus += '<div class="af-erkannt"><span class="af-erkannt-nr">' + sicher(z.eingabe)
        + '</span> erkannt als Nummer eines <b>Mitbewerbers</b></div>';
    }

    if (z.status === 'keine_zuordnung' || z.status === 'nicht_verfuegbar') {
      // ⚠️ Kein „nicht im Sortiment". Siehe Kopfkommentar.
      return aus
        + '<div class="af-band warn"><b>Zu dieser Nummer haben wir noch keine Zuordnung.</b><br>'
        + 'Das heisst nicht, dass wir den Artikel nicht führen — wir kennen nur diese Nummer '
        + 'noch nicht. Schick sie uns, wir prüfen von Hand.</div>'
        + '<button type="button" class="af-knopf" data-af-anfrage="' + sicher(z.eingabe) + '">'
        + 'Diese Nummer prüfen lassen</button>';
    }

    if ((z.treffer || []).length) {
      aus += '<div class="af-zeilen ohne-wahl">' + kopfHtml(false)
        + z.treffer.map(function (t) { return zeileHtml(t); }).join('') + '</div>';
    }

    if ((z.treffer || []).length > 1) {
      aus += '<div class="af-band warn">ⓘ Mehrere Artikel tragen diese Nummer. '
        + 'Bitte den passenden wählen — die Unterschiede sind rot markiert.</div>';
    }
    return aus;
  }

  /**
   * Treffer der Freitextsuche.
   *
   * ⚠️⚠️ SICHTBAR GETRENNT von den Nummerntreffern und anders benannt: „könnte passen"
   * statt „Ihr Artikel". Ein Texttreffer ist geraten, ein Nummerntreffer ist belegt.
   * Wer beides gleich aussehen lässt, verkauft dem Kunden 1.5 mm² statt 0.5 mm² — und
   * er merkt es erst beim Auspacken.
   */
  function vorschlaegeHtml(liste) {
    if (!liste.length) { return ''; }

    var aus = '<div class="af-band info" style="margin-top:22px">'
      + 'Zu dieser Eingabe haben wir keine Nummer gefunden. <b>Könnte einer davon passen?</b><br>'
      + '<span class="af-klein">Das ist ein Vorschlag aus der Textsuche, keine Zuordnung — '
      + 'bitte Querschnitt und Abmessung prüfen.</span></div>';

    return aus + '<div class="af-zeilen ohne-wahl">' + kopfHtml(false)
      + liste.map(function (t) { return zeileHtml(t); }).join('') + '</div>';
  }

  // Sinnbilder fuer die Knoepfe je Zeile. Inline statt als Datei: kein weiterer
  // Abruf, und sie erben die Schriftfarbe ueber currentColor.
  var SVG_HERZ = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">'
    + '<path d="M12 20.3s-7.4-4.5-9.2-9.2C1.6 7.8 3.7 4.6 7 4.6c2 0 3.4 1.1 5 3 1.6-1.9 3-3 5-3 '
    + '3.3 0 5.4 3.2 4.2 6.5-1.8 4.7-9.2 9.2-9.2 9.2z" fill="none" stroke="currentColor" '
    + 'stroke-width="1.8" stroke-linejoin="round"/></svg>';
  var SVG_KORB = '<svg class="af-ico" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">'
    + '<path d="M3 4h2.2l2.1 10.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1L20.6 8H6.2" '
    + 'fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<circle cx="9.5" cy="19.5" r="1.4" fill="currentColor"/>'
    + '<circle cx="17" cy="19.5" r="1.4" fill="currentColor"/></svg>';
  var SVG_OK = '<svg class="af-ok" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">'
    + '<path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="2.2" '
    + 'stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /**
   * Kopfzeile der Trefferliste.
   *
   * @param mitWahl       true: Spalten fuer Kaestchen und „Deine Nr." (mehrere Nummern).
   * @param alleAn        Startzustand von „Alle auswählen".
   * @param mitVergleich  true: Preisvergleich und Ersparnis (Listenweg mit Preisspalte).
   */
  function kopfHtml(mitWahl, alleAn, mitVergleich, zweite) {
    return '<div class="af-zeile af-kopf">'
      + (mitWahl
          ? '<label class="af-kreuz" title="Alle auswählen"><input type="checkbox" data-af-alle="1" '
            + 'aria-label="Alle auswählen"' + (alleAn ? ' checked' : '') + '></label>'
            + '<span class="af-nr">Deine Nr.</span>'
          : '')
      + '<span></span><span>Artikel</span>'
      + (mitVergleich
          // ⚠️ Kurz halten: „Je Stück: wir / Sie" brach bei 118 px in drei Zeilen um.
          ? '<span class="r">Stückpreis</span><span class="r">' + (zweite || 'Ersparnis') + '</span>'
          : '<span class="r">Preis</span>')
      + '<span class="r">Menge</span><span></span></div>';
  }

  /**
   * Preisvergleich und Ersparnis einer Position — zwei Zellen.
   *
   * ⚠️ Beide Preise nebeneinander, nie nur die Differenz — sonst fällt eine
   * abweichende Gebindegrösse niemandem auf.
   */
  function vergleichZellen(v, t, hatPreis) {
    if (v.status === 'unvollstaendig') {
      var pack = (parseInt(t.pack, 10) || 0) / 100;
      var vpeT = !t.set && t.suq > 1;
      var je = vpeT ? pack / t.suq : pack;
      // ⭐ Ohne Preis, mit Bedarf: der MENGENPREIS dieser Position (vom Server,
      // auf ganze VPE gerundet). Ohne Bedarf bleibt die Zelle leer.
      var mp = v.mengenpreis;
      return '<div class="af-p"><b>CHF ' + einheitspreis(je) + '</b><span>'
        + (hatPreis ? 'dein Preis fehlt' : (vpeT ? 'VPE ' + sicher(t.suq) + ' à ' + geld(t.pack) : 'je Stück'))
        + '</span></div>'
        + (mp
            ? '<div class="af-sp"><b>CHF ' + zahlAnzeige(mp.betrag) + '</b><span>' + mp.vpe
              + (vpeT ? ' VPE' : ' Stk.') + ' · Mengenpreis</span></div>'
            : '<div class="af-sp"><span>' + (hatPreis ? 'nicht verglichen' : 'kein Bedarf') + '</span></div>');
    }

    var guenstiger = v.korb === 'guenstiger';
    var prozent = Math.abs(v.ersparnis_prozent || 0);
    var zeichen = guenstiger ? '−' : (prozent ? '+' : '±');

    var preis = '<div class="af-p"><b>CHF ' + einheitspreis(v.unser_je_einheit) + '</b>'
      + '<span>bisher ' + einheitspreis(v.kunde_je_einheit) + '</span></div>';

    // ⚠️ Ohne Bedarf KEIN Frankenbetrag — nur der Unterschied je Stueck in Prozent.
    // Siehe SavingsCalculator::vergleichJeEinheit().
    // ⭐ Dazu der Direktvergleich je VPE, sofern der Server ihn mitliefert.
    var dv = v.direkt;
    // ⭐ Auch je Zeile hervorgehoben: bei Ersparnis eine kleine gruene Marke.
    var pZeile = guenstiger
      ? '<i class="af-prozent klein">−' + prozent + ' %</i>'
      : zeichen + ' ' + prozent + ' %';
    var spar = v.ohne_menge
      ? '<div class="af-sp ' + (guenstiger ? 'spar' : 'mehr') + '"><b>' + zeichen + ' ' + prozent + ' %</b>'
        + '<span>' + (dv
            ? 'CHF ' + zahlAnzeige(Math.abs(dv.ersparnis || 0)) + (guenstiger ? ' je VPE' : ' mehr je VPE')
            : 'je Stück') + '</span></div>'
      : '<div class="af-sp ' + (guenstiger ? 'spar' : 'mehr') + '"><b>'
        + (guenstiger
            ? 'CHF ' + zahlAnzeige(v.ersparnis)
            : (v.ersparnis < 0 ? 'CHF ' + zahlAnzeige(Math.abs(v.ersparnis)) + ' mehr' : 'gleich'))
        + '</b><span>' + pZeile + ' · ' + mengeAnzeige(v.menge) + ' Stk.</span></div>';

    return preis + spar;
  }

  /**
   * Eine Trefferzeile.
   *
   * @param t   Karte aus der API.
   * @param o   Optional. Ist es gesetzt, bekommt die Zeile ein Auswahlkaestchen und
   *            die Spalte „Deine Nr." — das ist die Form fuer mehrere Nummern.
   *            { nr: Eingabe, an: vorausgewaehlt, offen: Teil einer Mehrdeutigkeit,
   *              vergleich: Position aus /finder/auswertung (Listenweg mit Preis),
   *              menge: Startwert des Mengenfelds in VPE, bedarf: Bedarf in Stueck }
   *
   * ⚠️⚠️ `an` ist bei mehrdeutigen Nummern IMMER false. Eine stille Vorauswahl legt
   * dem Kunden den falschen Querschnitt in den Korb, und er merkt es beim Auspacken.
   *
   * ⚠️ Korb und Favorit gibt es JE ZEILE und gesammelt unten. Bis zum 24.09.2026
   * gab es bei mehreren Nummern nur den Sammelweg — wer aus zwanzig Treffern
   * einen einzigen brauchte, musste neunzehn Haken entfernen. Damit das
   * Einzeln-Gelegte beim Sammelknopf nicht ein zweites Mal im Korb landet, nimmt
   * der Zeilenknopf nach Erfolg den Haken seiner Zeile weg (siehe Klick-Handler).
   */
  function zeileHtml(t, o) {
    var id = sicher(t.id);
    var link = '/products/' + sicher(t.handle);
    var vpe = t.suq && t.suq > 1;

    var bild = t.img
      ? '<img class="af-mini" src="' + sicher(t.img) + '" alt="" loading="lazy">'
      : '<span class="af-mini"></span>';

    /* ⚠️⚠️ NICHT IDENTISCH — das muss der Kunde sehen.
       `art` ist der match_type aus der Datenbank: exakt | gleichwertig |
       alternative. Folge am 24.09.2026 aufgefallen: 24092 ist bei uns eine
       Aderendhuelse mit 8 mm, beim Mitbewerber mit 10 mm — als „gleichwertig"
       korrekt erfasst, fuer den Kunden aber nicht erkennbar. Er haette 8 mm
       bestellt und es beim Auspacken gemerkt.
       ⚠️ In der Zeile als kurze Marke; der volle Satz steht im title. */
    var marke = t.art && t.art !== 'exakt'
      ? ' <span class="af-tag" title="Nicht identisch — bitte Abmessungen vergleichen">'
        + (t.art === 'alternative' ? 'Alternative' : 'gleichwertig') + ', nicht identisch</span>'
      : '';

    /* ⭐ Die Bezeichnung des Wettbewerbers, sofern gepflegt. Daran erkennt der Kunde
       ohne Nachdenken, dass er beim richtigen Artikel gelandet ist. Fehlt sie,
       entfaellt sie still. In der zweiten Zeile, notfalls mit Auslassung gekuerzt:
       Sie bestaetigt, sie muss nicht vollstaendig gelesen werden. */
    var v = o && o.vergleich;
    var zweite = [sicher(t.sku)];
    if (!o && t.ihre_nummer) { zweite.push('Deine Nr. ' + sicher(t.ihre_nummer)); }
    // ⚠️ Im Vergleich zeigt die Preisspalte den Stueckpreis. Der Packpreis, zu dem
    // bestellt wird, muss trotzdem irgendwo stehen — hier.
    if (v) { zweite.push((vpe ? 'VPE ' + sicher(t.suq) + ' à ' : '') + 'CHF ' + geld(t.pack)); }
    if (t.ihr_titel) { zweite.push('bei dir: ' +sicher(t.ihr_titel)); }

    /* ⭐ DER EINHEITSPREIS neben dem Packpreis. Der Kunde vergleicht mit dem, was
       er heute je Stueck zahlt — „CHF 23.15 je VPE" allein hiesse im Kopf durch
       500 teilen.
       ⚠️ einheitspreis() gibt unter einem Franken VIER Stellen aus (0.0463).
       Mit dreien liesse sich die ausgewiesene Ersparnis nicht mehr aus den
       angezeigten Zahlen nachrechnen. Gleiche Regel wie in SavingsCalculator. */
    var unter = vpe
      ? 'VPE ' + sicher(t.suq)
        + (t.pack ? ' · <em>' + einheitspreis((parseInt(t.pack, 10) || 0) / 100 / t.suq) + ' / Stk.</em>' : '')
      : 'je Stück';

    return '<div class="af-zeile' + (o && o.offen ? ' af-offen' : '') + '">'
      + (o
          ? '<label class="af-kreuz"><input type="checkbox" data-af-wahl="' + id + '" aria-label="Auswählen"'
            + (o.an ? ' checked' : '') + '></label>'
            + '<span class="af-nr" title="' + sicher(o.nr) + '">' + sicher(o.nr) + '</span>'
          : '')
      + '<a class="af-mini-a" href="' + link + '" tabindex="-1" aria-hidden="true">' + bild + '</a>'
      + '<div class="af-info">'
      + '<div class="af-z1"><a class="af-titel" href="' + link + '">' + sicher(t.title) + '</a>'
      + (t.unterschied ? ' <span class="af-merkmal">' + sicher(t.unterschied) + '</span>' : '')
      + marke + '</div>'
      + '<div class="af-z2">' + zweite.join(' · ') + '</div>'
      + '</div>'
      + (v ? vergleichZellen(v, t, o.hatPreis !== false) : '<div class="af-p"><b>CHF ' + geld(t.pack) + '</b><span>' + unter + '</span></div>')
      + '<input class="af-anz" type="number" min="1" step="1" value="' + ((o && o.menge) || 1) + '" inputmode="numeric" '
      + 'data-af-menge="' + id + '" aria-label="' + (vpe ? 'Menge in VPE' : 'Menge') + '"'
      + (o && o.bedarf > 0
          ? ' title="Dein Bedarf: ' + mengeAnzeige(o.bedarf) + ' Stk.' + (vpe ? ' = ' + ((o && o.menge) || 1) + ' VPE à ' + sicher(t.suq) : '') + '"'
          : '')
      + '>'
      + '<div class="af-tun">'
      + '<button type="button" class="af-sym" data-af-fav="' + id + '" '
      + 'title="Zu den Favoriten" aria-label="Zu den Favoriten">' + SVG_HERZ + '</button>'
      + '<button type="button" class="af-sym rot" data-af-korb="' + id + '" '
      + 'title="In den Warenkorb" aria-label="In den Warenkorb">' + SVG_KORB + SVG_OK + '</button>'
      + '</div></div>';
  }

  // ── Einstieg B, Schritt 1: Datei oder Einfügen ──────────────────────────

  var ablegen = el('af-ablegen');

  ['dragenter', 'dragover'].forEach(function (e) {
    ablegen.addEventListener(e, function (ev) {
      ev.preventDefault(); ablegen.classList.add('drueber');
    });
  });
  ['dragleave', 'drop'].forEach(function (e) {
    ablegen.addEventListener(e, function (ev) {
      ev.preventDefault(); ablegen.classList.remove('drueber');
    });
  });
  ablegen.addEventListener('drop', function (ev) {
    if (ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files[0]) {
      leseDatei(ev.dataTransfer.files[0]);
    }
  });
  el('af-datei').addEventListener('change', function () {
    if (this.files && this.files[0]) { leseDatei(this.files[0]); }
  });

  el('af-lesen').addEventListener('click', function () {
    var text = el('af-einfuegen').value.trim();
    if (!text) { fehler('Bitte eine Datei wählen oder eine Liste einfügen.'); return; }
    leseText(text);
  });

  function leseDatei(datei) {
    fehlerWeg();
    var fd = new FormData();
    fd.append('file', datei);

    fetch(BASIS + '/api/b2b/import/parse', {
      method: 'POST', headers: { 'X-Api-Key': KEY }, body: fd
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { throw new Error(j.error || 'Antwort ' + r.status); }
        return j;
      });
    }).then(function (a) {
      zellen = (a.rows || []).map(function (r) { return r.raw || []; });
      spaltenZeigen(a.truncated);
    }).catch(function (e) {
      fehler(e.message || 'Die Datei konnte nicht gelesen werden.');
    });
  }

  /**
   * Eingefügter Text.
   *
   * ⚠️ Bewusst im Browser zerlegt statt über /import/parse: eine Zwischenablage ist
   * keine Datei, und der Endpunkt erwartet einen Upload. Tabulator zuerst — so kopiert
   * Excel —, Semikolon und Komma als Rückfall.
   */
  function leseText(text) {
    fehlerWeg();
    zellen = text.split(/\r?\n/).filter(function (z) { return z.trim() !== ''; })
      .slice(0, MAX_ZEILEN)
      .map(function (z) {
        var t = z.indexOf('\t') >= 0 ? '\t' : (z.indexOf(';') >= 0 ? ';' : ',');
        return z.split(t).map(function (c) { return c.trim(); });
      });
    if (!zellen.length) { fehler('In der Eingabe steht keine Zeile.'); return; }
    spaltenZeigen(false);
  }

  // ── Schritt 2: Spalten erkennen ─────────────────────────────────────────

  /**
   * Spalten raten und das Ergebnis zeigen — der Kunde korrigiert höchstens.
   *
   * ⭐ Erst an der Kopfzeile, dann am Inhalt. Eine Vorlage zum Herunterladen wäre der
   * bequemere Weg für uns und der unbequemere für ihn: er müsste seine Liste umbauen,
   * bevor er sieht, ob sich das lohnt.
   */
  function spaltenZeigen(gekappt) {
    var kopf = zellen[0] || [];
    var hatKopf = hatKopfzeile();
    var spalten = Math.max.apply(null, zellen.slice(0, 20).map(function (z) { return z.length; }));

    zuordnung = {};
    for (var i = 0; i < spalten; i++) { zuordnung[i] = raten(i, hatKopf ? kopf[i] : '', hatKopf); }

    // ⚠️ Genau EINE Nummernspalte. Ohne sie ist die ganze Liste unbrauchbar, also
    // notfalls die erste Spalte nehmen — die trägt sie in der Praxis fast immer.
    if (!Object.keys(zuordnung).some(function (k) { return zuordnung[k] === 'nr'; })) { zuordnung[0] = 'nr'; }

    el('af-spalten-kopf').textContent = 'Wir haben deine Datei gelesen: '
      + zellen.length + (zellen.length === 1 ? ' Zeile' : ' Zeilen') + ', ' + spalten + ' Spalten.';

    var html = '';
    for (var s = 0; s < spalten; s++) {
      var proben = zellen.slice(hatKopf ? 1 : 0, (hatKopf ? 1 : 0) + 4)
        .map(function (z) { return z[s] || ''; }).filter(Boolean).join(' · ');
      html += '<div class="af-spalte">'
        + '<span><b>Spalte ' + String.fromCharCode(65 + s) + '</b></span>'
        + '<select data-af-spalte="' + s + '">'
        + wahlHtml(zuordnung[s])
        + '</select>'
        + '<span class="af-probe">' + sicher(proben) + '</span>'
        + '<span class="af-haken">' + (zuordnung[s] ? '✓ erkannt' : '') + '</span>'
        + '</div>';
    }
    el('af-spalten').innerHTML = html;

    el('af-spalten').querySelectorAll('select').forEach(function (s) {
      s.addEventListener('change', function () { zuordnung[this.dataset.afSpalte | 0] = this.value; });
    });

    if (gekappt) {
      fehler('Deine Datei ist länger als ' + MAX_ZEILEN + ' Zeilen — wir haben die ersten ' + MAX_ZEILEN + ' genommen.');
    }
    zeigen('spalten');
  }

  function wahlHtml(gewaehlt) {
    return [['', 'ignorieren'], ['nr', 'Artikelnummer'], ['preis', 'Dein Preis'], ['menge', 'Dein Bedarf']]
      .map(function (o) {
        return '<option value="' + o[0] + '"' + (gewaehlt === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
      }).join('');
  }

  function raten(index, kopfzelle, hatKopf) {
    if (hatKopf) {
      var k = String(kopfzelle || '').toLowerCase();
      if (/art.*nr|artikel|bestell|nummer/.test(k)) { return 'nr'; }
      if (/preis|chf|kosten/.test(k)) { return 'preis'; }
      if (/menge|bedarf|stk|stück|stueck|anzahl/.test(k)) { return 'menge'; }
      if (k) { return ''; }
    }
    // Ohne Kopfzeile am Inhalt raten: Nummern sehen anders aus als Preise.
    var werte = zellen.slice(0, 8).map(function (z) { return String(z[index] || '').trim(); }).filter(Boolean);
    if (!werte.length) { return ''; }
    var zahlen = werte.filter(function (w) { return /^[\d'.,]+$/.test(w); });
    if (zahlen.length / werte.length < 0.6) { return ''; }
    // Kommastellen -> Preis; ganze Zahlen -> Nummer oder Menge.
    var mitKomma = zahlen.filter(function (w) { return /[.,]\d/.test(w); }).length;
    return mitKomma > zahlen.length / 2 ? 'preis' : (index === 0 ? 'nr' : '');
  }

  // ── Schritt 3: prüfen ───────────────────────────────────────────────────

  /**
   * Hat die Liste eine Kopfzeile?
   *
   * ⚠️⚠️ EINE Regel fuer alle Stellen. Bis zum 24.09.2026 stand sie zweimal da,
   * und die zweite Fassung kannte „stk" und „bezeichn" nicht. Eine Liste mit der
   * Kopfzeile „Bezeichnung;Stk." wurde deshalb beim Lesen richtig erkannt, beim
   * Pruefen aber als Datenzeile mitgeschickt — und alle Zeilennummern verrutschten
   * um eins: Preis und Bedarf landeten beim Artikel der Nachbarzeile.
   */
  function hatKopfzeile() {
    return (zellen[0] || []).some(function (c) { return /art|nummer|preis|menge|bedarf|stk|bezeichn/i.test(c); });
  }

  function datenReihen() { return zellen.slice(hatKopfzeile() ? 1 : 0); }

  function spalteFuer(rolle) {
    return Object.keys(zuordnung).filter(function (k) { return zuordnung[k] === rolle; })[0];
  }

  el('af-pruefen').addEventListener('click', function () {
    var spalteNr = spalteFuer('nr');
    if (spalteNr === undefined) { fehler('Bitte eine Spalte als Artikelnummer wählen.'); return; }

    var senden = datenReihen().map(function (z, i) { return { i: i, nr: z[spalteNr] || '' }; })
      .filter(function (r) { return r.nr !== ''; });

    if (!senden.length) { fehler('In der gewählten Spalte steht keine Artikelnummer.'); return; }

    fehlerWeg();
    this.disabled = true;
    var knopf = this;

    api('/api/b2b/finder/resolve', { zeilen: senden }).then(function (a) {
      knopf.disabled = false;
      aufgeloest = a.zeilen || [];
      wahl = {};

      // ⭐ Der Zwischenschritt „Kurz prüfen" erscheint NUR, wenn es etwas zu
      // entscheiden gibt. Vorher stand er immer da, mit einer zugeklappten
      // Tabelle der eindeutigen Zeilen — ein Klick mehr ohne Nutzen.
      if (aufgeloest.some(function (z) { return z.status === 'mehrdeutig'; })) {
        pruefenZeigen();
      } else {
        auswerten(knopf);
      }
    }).catch(function (e) {
      knopf.disabled = false;
      fehler(fehlerText(e, 'Die Prüfung'));
      if (window.console) { console.warn('[Artikelfinder]', e); }
    });
  });

  function pruefenZeigen() {
    var mehrdeutig = aufgeloest.filter(function (z) { return z.status === 'mehrdeutig'; });
    var gefunden = aufgeloest.filter(function (z) {
      return z.status === 'ok' || z.status === 'mehrdeutig';
    }).length;

    var html = '<p class="af-hilfe" style="margin-top:0">' + gefunden + ' von ' + aufgeloest.length
      + ' Positionen zugeordnet. Bei ' + mehrdeutig.length
      + (mehrdeutig.length === 1 ? ' Position passt' : ' Positionen passen')
      + ' mehr als ein Artikel — bitte jeweils den richtigen wählen.</p>';

    // ⚠️ Ohne Vorauswahl: das ist die einzige Stelle, an der wirklich entschieden
    // werden muss. Eine stille Vorauswahl legt dem Kunden den falschen Querschnitt
    // in den Korb — der Fehler fällt erst beim Auspacken auf.
    if (mehrdeutig.length) {
      mehrdeutig.forEach(function (z) {
        html += '<div class="af-kasten af-auswahl"><b>Deine Nr. ' + sicher(z.eingabe) + '</b>'
          + '<div style="margin-top:9px">';
        z.treffer.forEach(function (t, n) {
          html += '<label><input type="radio" name="af-w' + z.i + '" value="' + sicher(t.sku) + '"'
            + (n === 0 ? '' : '') + '>'
            + '<span><b>' + sicher(t.title) + '</b> '
            + '<span class="af-merkmal">' + sicher(t.unterschied) + '</span><br>'
            + '<span class="af-klein">' + sicher(t.sku) + ' · CHF ' + geld(t.pack)
            + (t.suq && t.suq > 1 ? ' je VPE ' + sicher(t.suq) : '') + '</span></span></label>';
        });
        html += '</div></div>';
      });
    }

    // Die Zeilen ohne Zuordnung stehen in der Auswertung — hier nur, was zu tun ist.
    el('af-pruefliste').innerHTML = html;
    zeigen('pruefen');
  }

  // ── Schritt 4: Auswertung ───────────────────────────────────────────────

  el('af-auswerten').addEventListener('click', function () {
    // Getroffene Auswahl einsammeln.
    wahl = {};
    wurzel.querySelectorAll('input[type=radio][name^=af-w]:checked').forEach(function (r) {
      wahl[r.name.slice(4) | 0] = r.value;
    });

    var offen = aufgeloest.filter(function (z) {
      return z.status === 'mehrdeutig' && !wahl[z.i];
    });
    if (offen.length) {
      fehler('Bitte noch ' + offen.length + (offen.length === 1 ? ' Zeile' : ' Zeilen') + ' entscheiden.');
      return;
    }

    auswerten(this);
  });

  /**
   * Die zugeordneten Positionen rechnen lassen und das Ergebnis zeigen.
   *
   * ⚠️⚠️ Es geht JEDE zugeordnete Position hinaus, auch ohne Preis oder Bedarf.
   * Bis zum 24.09.2026 wurden solche Positionen hier herausgefiltert, und fehlte
   * eine der beiden Spalten ganz, gab es statt einer Auswertung nur den Satz
   * „Wir haben N Ihrer Positionen im Sortiment" — dazu einen Korbknopf, der jede
   * Position mit Menge 1 legte, gleich welcher Bedarf in der Liste stand. Der
   * Server unterscheidet jetzt selbst: voll gerechnet, nur je Stueck verglichen,
   * oder ohne Preis (siehe CompetitorMatchController::auswertung()).
   *
   * ⚠️ Gerechnet wird NUR auf dem Server. Packpreis und Verkaufseinheit kommen dort
   * aus dem Index, nicht aus dem Browser — eine zweite Rechnung hier liefe
   * frueher oder spaeter um einen Rappen auseinander.
   */
  function auswerten(knopf) {
    var spalteP = spalteFuer('preis');
    var spalteM = spalteFuer('menge');
    var reihen = datenReihen();
    var einheit = (wurzel.querySelector('input[name=af-einheit]:checked') || {}).value || 'stueck';
    var zeitraum = (wurzel.querySelector('input[name=af-zeitraum]:checked') || {}).value || 'bestellung';
    var haeufigkeit = Math.max(1, Math.min(365, parseInt((el('af-haeufigkeit') || {}).value, 10) || 1));

    // `bezug` laeuft parallel zu `positionen`: Der Server antwortet mit dem Index
    // in DIESER Liste, die Eingabe des Kunden kennt er nicht.
    var positionen = [];
    var bezug = [];
    letzteAnfrage = null;
    aufgeloest.forEach(function (z) {
      if (z.status !== 'ok' && z.status !== 'mehrdeutig') { return; }
      var sku = wahl[z.i] || ((z.treffer || [])[0] || {}).sku || '';
      if (!sku) { return; }
      var r = reihen[z.i] || [];
      positionen.push({
        sku: sku,
        preis: spalteP !== undefined ? zahl(r[spalteP]) : 0,
        menge: spalteM !== undefined ? zahl(r[spalteM]) : 0
      });
      bezug.push(z);
    });

    var zeigenMit = function (a) {
      try {
        listeZeigen(a, bezug, spalteP !== undefined, spalteM !== undefined, einheit, zeitraum);
      } catch (fehlerBeimZeigen) {
        // ⚠️ Eigenes try/catch aus demselben Grund wie bei mehrfachZeigen():
        // sonst saehe ein Fehler in der Anzeige aus wie ein Netzproblem.
        fehler('Die Auswertung konnte nicht angezeigt werden — bitte melde uns das.');
        if (window.console) { console.error('[Artikelfinder] listeZeigen() ist gescheitert:', fehlerBeimZeigen); }
      }
    };

    if (!positionen.length) { zeigenMit({ positionen: [], summe: {} }); return; }

    // ⭐ Fuer das PDF gemerkt: dieselbe Anfrage, dazu je Position die Eingabe des
    // Kunden (nur zur Anzeige). Das PDF rechnet auf dem Server neu — mit genau
    // diesen Werten, darum stimmen Bildschirm und PDF ueberein.
    letzteAnfrage = {
      positionen: positionen.map(function (p, k) {
        return { sku: p.sku, preis: p.preis, menge: p.menge, nr: bezug[k].eingabe };
      }),
      einheit: einheit,
      zeitraum: zeitraum,
      haeufigkeit: haeufigkeit,
      ohne: []
    };

    fehlerWeg();
    knopf.disabled = true;

    api('/api/b2b/finder/auswertung', {
      positionen: positionen, einheit: einheit, zeitraum: zeitraum, haeufigkeit: haeufigkeit
    })
      .then(function (a) {
        knopf.disabled = false;
        zeigenMit(a);
      }).catch(function (e) {
        knopf.disabled = false;
        fehler(fehlerText(e, 'Die Auswertung'));
        if (window.console) { console.warn('[Artikelfinder]', e); }
      });
  }

  /** Schweizer Schreibweise: 12'000 und 0,053 muessen beide ankommen. */
  function zahl(roh) {
    var s = String(roh || '').replace(/['’\s]/g, '').replace(',', '.');
    var n = parseFloat(s);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function zahlAnzeige(n) {
    return window.SU && window.SU.money ? window.SU.money(n) : (parseFloat(n) || 0).toFixed(2);
  }

  /** Mengen mit Schweizer Tausendertrennung: 12'000. Meterware behaelt ihre
   *  Nachkommastellen — 2.5 m zu „3" zu runden hiesse, eine andere Zahl zu zeigen
   *  als die, mit der gerechnet wurde. */
  function mengeAnzeige(n) {
    var x = parseFloat(n) || 0;
    var teile = String(x).split('.');
    teile[0] = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '\'');
    return teile.join('.');
  }

  /**
   * Bedarf (Stueck) in Verkaufseinheiten fuer den Korb.
   *
   * ⚠️⚠️ Der Bedarf steht IMMER in Stueck bzw. Meter — so rechnet auch der
   * Server (SavingsCalculator::position() multipliziert ihn mit dem Preis je
   * Einheit). Der Warenkorb zaehlt aber Verkaufseinheiten. 1'000 Aderendhuelsen
   * bei VPE 500 sind 2 VPE, nicht 1'000 — ohne diese Umrechnung laegen 500'000
   * Stueck im Korb.
   * ⚠️ Aufgerundet: Wer 700 braucht, bekommt 2 VPE, nicht 1.
   */
  function vpeFuerBedarf(t, bedarf) {
    var n = parseFloat(bedarf) || 0;
    if (n <= 0) { return 1; }
    var q = (!t.set && t.suq && t.suq > 1) ? parseFloat(t.suq) : 1;
    return Math.max(1, Math.ceil(n / q - 1e-9));
  }

  /**
   * Ergebnis des Listenwegs: Summe oben, darunter eine Zeile je Position.
   *
   * ⭐ Seit 24.09.2026 dieselbe Zeilenform wie die Suche — mit Korb und Favorit je
   * Zeile, Auswahl und Sammelleiste. Vorher standen hier zwei Tabellen in
   * <details>, ohne Bild, ohne Knopf je Artikel, und der einzige Korbknopf legte
   * alle guenstigeren Positionen mit Menge 1.
   *
   * Drei Gruppen, in dieser Reihenfolge:
   *   1. guenstiger bei uns   (vorausgewaehlt, groesste Ersparnis zuerst)
   *   2. gleich oder teurer   (NICHT vorausgewaehlt — und NICHT versteckt: wer die
   *                            teureren wegklappt, wird beim ersten Nachrechnen
   *                            unglaubwuerdig)
   *   3. ohne Preis           (vorausgewaehlt; ohne Preisspalte sind das alle)
   *
   * @param a         Antwort von /finder/auswertung
   * @param bezug     Zeilen aus `aufgeloest`, parallel zu den gesendeten Positionen
   * @param hatPreis  gab es eine Preisspalte?
   * @param hatMenge  gab es eine Bedarfsspalte?
   * @param einheit   'stueck' | 'gebinde' — so hat der Kunde seine Preise angegeben
   * @param zeitraum  'bestellung' | 'jahr' — wofuer der Bedarf gilt
   */
  function listeZeigen(a, bezug, hatPreis, hatMenge, einheit, zeitraum) {
    var guenstig = [];
    var teurer = [];
    var ohnePreis = [];
    var nichtGerechnet = [];

    karten = {};
    (a.positionen || []).forEach(function (p) {
      var z = bezug[p.i];
      if (!z) { return; }
      var t = p.treffer;
      if (!t) { nichtGerechnet.push(z.eingabe); return; }
      karten[t.id] = t;

      var e = { p: p, t: t, nr: z.eingabe };
      if (p.status === 'unvollstaendig') { ohnePreis.push(e); }
      else if (p.status === 'ok' && p.korb === 'guenstiger') { guenstig.push(e); }
      else if (p.status === 'ok') { teurer.push(e); }
      else { nichtGerechnet.push(z.eingabe); }
    });

    // Groesste Ersparnis zuerst; Positionen ohne Bedarf (nur Prozent) danach.
    guenstig.sort(function (x, y) {
      if (!!x.p.ohne_menge !== !!y.p.ohne_menge) { return x.p.ohne_menge ? 1 : -1; }
      return x.p.ohne_menge
        ? (y.p.ersparnis_prozent || 0) - (x.p.ersparnis_prozent || 0)
        : (y.p.ersparnis || 0) - (x.p.ersparnis || 0);
    });

    var ohne = aufgeloest.filter(function (z) {
      return z.status === 'keine_zuordnung' || z.status === 'nicht_verfuegbar';
    }).map(function (z) { return z.eingabe; }).concat(nichtGerechnet);

    if (letzteAnfrage) { letzteAnfrage.ohne = ohne; }

    // ⭐ Oben die zwei Wege aus der Auswertung heraus. Der Rest der Seite (Suchfeld,
    // Listen-Einstieg) ist in diesem Schritt ausgeblendet — siehe zeigen().
    var html = '<div class="af-kopfleiste">'
      + '<button type="button" class="af-knopf leer klein" data-af-neu="1">← Neue Prüfung</button>'
      + (zeilenAnzahl(guenstig, teurer, ohnePreis)
          ? '<button type="button" class="af-knopf rot klein" data-af-pdf="1">PDF herunterladen</button>'
          : '')
      + '</div>';

    html += summeHtml(a, hatPreis, hatMenge, einheit, zeitraum, {
      guenstig: guenstig.length,
      nurStueckGuenstig: guenstig.filter(function (e) { return e.p.ohne_menge; }).length,
      nurStueck: guenstig.concat(teurer).filter(function (e) { return e.p.ohne_menge; }).length,
      teurer: teurer.length,
      ohnePreis: ohnePreis.length,
      ohne: ohne.length
    });

    // ⚠️ Beim JAHRESbedarf steht im Mengenfeld eine VPE, nicht der ganze Bedarf:
    // Niemand bestellt den Bedarf eines Jahres auf einmal, und 20 Kartons im Korb,
    // die keiner so wollte, sind schlimmer als ein Feld, das man selbst fuellt.
    var mengeAusBedarf = zeitraum !== 'jahr';

    var zeilen = guenstig.length + teurer.length + ohnePreis.length;
    if (zeilen) {
      // ⚠️ `mit-vergleich` schaltet das Raster auf acht Spalten. Es gilt mit
      // Preisspalte (Ersparnis) UND mit Bedarfsspalte (Mengenpreis) — nur wer
      // keins von beidem hat, bekommt die schlichte Trefferzeile.
      var mitSpalte = hatPreis || hatMenge;
      html += '<div class="af-zeilen' + (mitSpalte ? ' mit-vergleich' : '') + '">'
        + kopfHtml(true, !teurer.length, mitSpalte, hatPreis ? 'Ersparnis' : 'Mengenpreis');

      var gruppe = function (titel, liste, an) {
        if (!liste.length) { return; }
        html += '<div class="af-zeile-gruppe">' + titel + ' <span>' + liste.length + '</span></div>';
        liste.forEach(function (e) {
          html += zeileHtml(e.t, {
            nr: e.nr,
            an: an,
            vergleich: mitSpalte ? e.p : null,
            hatPreis: hatPreis,
            menge: mengeAusBedarf ? vpeFuerBedarf(e.t, e.p.menge) : 1,
            bedarf: mengeAusBedarf ? e.p.menge : 0
          });
        });
      };

      if (hatPreis) {
        gruppe('Günstiger bei uns', guenstig, true);
        gruppe('Gleich oder teurer bei uns', teurer, false);
        gruppe('Ohne Preis in deiner Liste', ohnePreis, true);
      } else {
        gruppe('Bei uns im Sortiment', ohnePreis, true);
      }

      html += '</div>';
    }

    if (ohne.length) {
      html += '<div class="af-band info" style="margin-top:22px">'
        + '<b>' + ohne.length + (ohne.length === 1 ? ' Position' : ' Positionen')
        + ' konnten wir nicht zuordnen:</b> ' + ohne.map(sicher).join(', ') + '<br>'
        + 'Das heisst nicht, dass wir die Artikel nicht führen — wir kennen nur diese '
        + 'Nummern noch nicht.'
        + '<div style="margin-top:11px"><button type="button" class="af-knopf leer klein" '
        + 'data-af-anfrage-alle="1">Prüfen lassen</button></div></div>';
    }

    if (zeilen) {
      html += '<div class="af-sammel">'
        + '<span class="af-sammel-zahl" data-af-zaehler>0 ausgewählt</span>'
        + '<button type="button" class="af-knopf leer klein" data-af-fav-wahl="1">Auswahl merken</button>'
        + '<button type="button" class="af-knopf rot klein" data-af-korb-wahl="1">'
        + 'Auswahl in den Warenkorb</button></div>';
    }

    html += '<div class="af-reihe"><button type="button" class="af-knopf leer klein" '
      + 'data-af-zurueck="spalten">Spalten ändern</button></div>';

    el('af-auswertung').innerHTML = html;
    zeigen('auswertung');
    zaehlerAktualisieren();
  }

  function zeilenAnzahl(a, b, c) { return a.length + b.length + c.length; }

  /**
   * Der schwarze Ergebnisblock: eine oder zwei grosse Zahlen, rechts die Einordnung.
   *
   * @param zahlen  [{titel, wert, gut, unter, klein}]
   * @param neben   [[Beschriftung, Wert, klein?]]
   */
  function ergebnisBlock(zahlen, neben) {
    return '<div class="af-ergebnis"><div class="af-ergebnis-haupt">'
      + zahlen.map(function (z) {
        return '<div class="af-ergebnis-zahl' + (z.gut ? ' gut' : '') + '">'
          + '<span>' + z.titel + '</span>' + wertZeile(z.wert, z.prozent, z.vor) + '<em>' + z.unter + '</em>'
          + (z.klein ? '<small>' + z.klein + '</small>' : '') + '</div>';
      }).join('')
      + '</div>'
      + (neben.length
          ? '<dl class="af-ergebnis-neben">' + neben.map(function (x) {
            return '<div><dt>' + x[0] + '</dt><dd' + (x[2] ? ' class="klein"' : '') + '>' + x[1] + '</dd></div>';
          }).join('') + '</dl>'
          : '')
      + '</div>';
  }

  /**
   * Die prozentuale Ersparnis als eigene Marke neben dem Betrag.
   *
   * ⭐ Seit 24.09.2026 hervorgehoben: Stand bis dahin klein in der Unterzeile.
   * Der Prozentwert ist die Zahl, die ein Einkaeufer weitererzaehlt („22 %
   * guenstiger"), der Frankenbetrag haengt an der Menge. Darum gleich gross
   * gewichtet, in derselben Zeile, und gruen — nur bei echter Ersparnis. Ein
   * „0 %" oder ein Minus bekommt KEINE Marke; sonst sahe ein Nachteil aus wie
   * ein Verkaufsargument.
   *
   * @param p    Prozent (positiv = guenstiger bei uns)
   * @param vor  optionales Praefix, z. B. „Ø" fuer einen Durchschnitt
   */
  function prozentMarke(p, vor) {
    var n = parseFloat(p) || 0;
    if (n <= 0) { return ''; }
    return '<i class="af-prozent">' + (vor ? vor + ' ' : '') + '−' + n + ' %</i>';
  }

  function wertZeile(wert, prozent, vor) {
    return '<div class="af-wert"><b>' + wert + '</b>' + prozentMarke(prozent, vor) + '</div>';
  }

  /**
   * Zusatzzeilen unter der Hauptzahl, wenn eine Liste GEMISCHT ist: einige
   * Positionen mit Bedarf, andere nur mit Preis (Direktvergleich) oder nur mit
   * Bedarf (Mengenpreis). Diese Summen bleiben getrennt — siehe Controller.
   */
  function zusatzHtml(d, mp, zeitraum, faktor) {
    var aus = '';
    if (d && d.anzahl) {
      aus += '<p class="af-zusatz"><b>Direktvergleich</b> für ' + d.anzahl
        + (d.anzahl === 1 ? ' Position' : ' Positionen') + ' ohne Bedarf, je 1 VPE: bisher CHF '
        + zahlAnzeige(d.kunde_gesamt) + ', bei uns CHF ' + zahlAnzeige(d.unser_gesamt) + ' — '
        + ((d.ersparnis || 0) > 0
            ? 'du sparst <b>CHF ' + zahlAnzeige(d.ersparnis) + '</b>.'
            : 'bei uns CHF ' + zahlAnzeige(Math.abs(d.ersparnis || 0)) + ' mehr.')
        + '</p>';
    }
    if (mp && mp.anzahl) {
      // ⚠️ Zeitraum-Regel wie in summeHtml(): „pro Jahr" nur beim Jahresbedarf.
      var mehrere = zeitraum !== 'jahr' && faktor > 1;
      aus += '<p class="af-zusatz"><b>Mengenpreis</b> für ' + mp.anzahl
        + (mp.anzahl === 1 ? ' Position' : ' Positionen') + ' ohne Preis: <b>CHF '
        + zahlAnzeige(mp.betrag_jahr) + '</b> '
        + (zeitraum === 'jahr' ? 'pro Jahr' : (mehrere ? 'für ' + faktor + ' Bestellungen' : 'pro Bestellung'))
        + (mehrere ? ' (CHF ' + zahlAnzeige(mp.betrag) + ' pro Bestellung)' : '')
        + '.</p>';
    }
    return aus;
  }

  /**
   * Der Kasten ueber der Liste — je nachdem, was die Liste hergab.
   *
   * ⚠️⚠️ Es werden BEIDE Ersparniszahlen gezeigt, wenn es teurere Positionen gibt:
   * die ueber alles (gegengerechnet) gross, die nur ueber die guenstigeren klein
   * darunter. Nur die zweite zu zeigen waere geschoent — siehe
   * SavingsCalculator::summe().
   */
  function summeHtml(a, hatPreis, hatMenge, einheit, zeitraum, n) {
    var s = a.summe || {};
    var j = a.jahr || s;
    var faktor = (a.jahr && a.jahr.faktor) || 1;
    var html = '';

    // ⚠️⚠️ ZEITRAUM-REGEL (Vorgabe 24.09.2026, nach zwei Anlaeufen):
    //   Jahresbedarf    -> grosse Zahl „pro Jahr"
    //   Einkaufsbedarf  -> grosse Zahl = GESAMT ueber alle Bestellungen, beschriftet
    //                      „für 4 Bestellungen"; klein darunter „CHF … pro Bestellung"
    // Beim Einkaufsbedarf wird NIE ein Jahr behauptet: Wie oft jemand bestellt, sagt
    // nichts darueber, in welchem Zeitraum. (Erster Anlauf: Gesamt als „pro Jahr" —
    // falsch deklariert. Zweiter: nur pro Bestellung gross — Gesamt zu klein.)
    // `j` / `a.jahr` heisst intern weiter so; es ist schlicht Summe × Anzahl.
    var jahrBedarf = zeitraum === 'jahr';
    var mehrfach = !jahrBedarf && faktor > 1;
    var wofuer = jahrBedarf ? 'pro Jahr' : (mehrfach ? 'für ' + faktor + ' Bestellungen' : 'pro Bestellung');
    var hoch = function (betrag, mehr) {
      return mehrfach
        ? '<small>CHF ' + zahlAnzeige(Math.abs(betrag || 0)) + (mehr ? ' mehr' : '') + ' pro Bestellung</small>'
        : '';
    };
    var d = a.direkt || {};
    var mp = a.mengenpreis || {};

    if (hatPreis && hatMenge && s.anzahl) {
      var spart = (j.ersparnis || 0) > 0;

      // ⚠️⚠️ BEIDE Ersparniszahlen, gleich gross nebeneinander (seit 24.09.2026).
      // „Gesamter Bedarf" rechnet die teureren Positionen gegen, „nur günstigere"
      // zeigt den Hebel. Nur die zweite zu zeigen waere geschoent, nur die erste
      // verschwiege das Angebot. Gleiche Zahlen und Texte wie im PDF (ErsparnisPdf).
      html += '<div class="af-ergebnis">'
        + '<div class="af-ergebnis-haupt">'
        + '<div class="af-ergebnis-zahl' + (spart ? ' gut' : '') + '">'
        + '<span>Ersparnis gesamter Bedarf</span>'
        // ⚠️ „mehr" nur bei echtem Minus — bei Gleichstand stuende sonst „CHF 0.00 mehr".
        + wertZeile('CHF ' + zahlAnzeige(Math.abs(j.ersparnis || 0)) + ((j.ersparnis || 0) < 0 ? ' mehr' : ''),
            spart ? j.ersparnis_prozent : 0)
        + '<em>' + (spart ? 'weniger als heute · '
            : ((j.ersparnis || 0) < 0 ? 'bei uns teurer · ' : 'gleich teuer · ')) + wofuer + '</em>'
        // ⚠️ Betrag OHNE Vorzeichen, Richtung als Wort — „CHF -13.90" stand hier bis
        // zum 24.09.2026 und liest sich wie ein Tippfehler.
        + hoch(s.ersparnis, (s.ersparnis || 0) < 0)
        + '</div>'
        + '<div class="af-ergebnis-zahl' + ((j.ersparnis_guenstige || 0) > 0 ? ' gut' : '') + '">'
        + '<span>Ersparnis nur günstigere Produkte</span>'
        + wertZeile('CHF ' + zahlAnzeige(j.ersparnis_guenstige || 0), j.ersparnis_guenstige_prozent)
        // ⚠️⚠️ Gezaehlt werden ALLE guenstigeren Produkte — dieselbe Zahl wie die
        // Marke „3 günstiger" darunter. Bis 24.09.2026 stand hier nur die Zahl der
        // Positionen IN der Summe (2), und oben und unten widersprachen sich. Wer
        // keinen Bedarf hat, steckt nicht im Betrag — das sagt die kleine Zeile.
        + '<em>' + n.guenstig + (n.guenstig === 1 ? ' Produkt' : ' Produkte') + ' günstiger · '
        + wofuer + '</em>'
        + (n.nurStueckGuenstig
            ? '<small>davon ' + n.nurStueckGuenstig + ' ohne Bedarf — nicht im Betrag, siehe Direktvergleich</small>'
            : '')
        + hoch(s.ersparnis_guenstige, false)
        + '</div></div>'
        + '<dl class="af-ergebnis-neben">'
        + '<div><dt>Heute, zu deinen Preisen</dt><dd>CHF ' + zahlAnzeige(j.kunde_gesamt) + '</dd></div>'
        + '<div><dt>Bei uns</dt><dd>CHF ' + zahlAnzeige(j.unser_gesamt) + '</dd></div>'
        + '<div><dt>Gilt</dt><dd class="klein">' + wofuer + '</dd></div>'
        + '</dl></div>';
      html += zusatzHtml(d, mp, zeitraum, faktor);
    } else if (hatPreis && d.anzahl) {
      // ⭐ DIREKTVERGLEICH (seit 24.09.2026): Preise, aber kein Bedarf. Automatisch
      // je eine VPE von jedem Artikel — eine Menge, die man bestellen kann, und
      // ein Frankenbetrag, den man nachrechnen kann. Vorher stand hier nur
      // „N von M günstiger".
      // ⭐ Zuerst die Frage, die der Kunde stellt: Bei wie vielen Produkten seid
      // ihr guenstiger — und um wie viel im Schnitt? Daneben der Frankenbetrag
      // je VPE nur ueber die guenstigeren, rechts die Summe ueber alles.
      var dSumme = d.ersparnis || 0;
      html += ergebnisBlock([
        {
          titel: 'Günstiger bei uns',
          wert: n.guenstig + ' von ' + (n.guenstig + n.teurer),
          gut: n.guenstig > 0,
          // Die Marke traegt den Schnitt; „Ø" sagt, dass es ein Mittelwert ist.
          prozent: n.guenstig ? d.schnitt_prozent_guenstiger : 0,
          vor: 'Ø',
          unter: (n.guenstig + n.teurer === 1 ? 'Produkt' : 'Produkten')
            + (n.guenstig ? ' · im Schnitt günstiger je Stück' : '')
        },
        {
          titel: 'Ersparnis nur günstigere Produkte',
          wert: 'CHF ' + zahlAnzeige(d.ersparnis_guenstige || 0),
          gut: (d.ersparnis_guenstige || 0) > 0,
          prozent: d.ersparnis_guenstige_prozent,
          unter: 'weniger als heute · je 1 VPE'
        }
      ], [
        ['Alle Produkte, je 1 VPE — bisher', 'CHF ' + zahlAnzeige(d.kunde_gesamt)],
        ['Alle Produkte, je 1 VPE — bei uns', 'CHF ' + zahlAnzeige(d.unser_gesamt)],
        [dSumme < 0 ? 'Differenz über alle' : 'Ersparnis über alle',
          'CHF ' + zahlAnzeige(Math.abs(dSumme)) + (dSumme < 0 ? ' mehr'
            : (dSumme > 0 ? ' · ' + (d.ersparnis_prozent || 0) + ' %' : ''))]
      ]);
      html += zusatzHtml({}, mp, zeitraum, faktor);
    } else if (mp.anzahl) {
      // ⭐ MENGENPREIS (seit 24.09.2026): Bedarf, aber kein Preis. Was die ganze
      // Menge bei uns kostet — auf ganze VPE gerundet, so wie bestellt wird.
      html += ergebnisBlock([{
        titel: 'Deine Menge bei uns',
        // Gesamt ueber alle Bestellungen gross, pro Bestellung klein — wie oben.
        wert: 'CHF ' + zahlAnzeige(mp.betrag_jahr),
        gut: false,
        unter: mp.anzahl + (mp.anzahl === 1 ? ' Position · ' : ' Positionen · ') + wofuer,
        klein: mehrfach ? 'CHF ' + zahlAnzeige(mp.betrag) + ' pro Bestellung' : ''
      }], [
        ['Gerechnet', 'auf ganze VPE aufgerundet', true],
        ['Mit deinen Preisen', 'zeigen wir, was du sparst', true]
      ]);
    } else {
      html += '<div class="af-band gut">Wir führen ' + ((a.positionen || []).length)
        + ' deiner Positionen. Mit einer Spalte „Dein Preis“ zeigen wir dir, wo du bei uns sparst, '
        + 'mit einer Spalte „Dein Bedarf“, was deine Menge bei uns kostet.</div>';
    }

    // Kennzahlen — dieselben Zahlen wie die Gruppen darunter, damit oben und
    // unten nie zweierlei steht (bis 24.09.2026: „2 günstiger" oben, „3" in der Gruppe).
    var marken = [];
    if (hatPreis && n.guenstig) { marken.push('<span class="spar">' + n.guenstig + ' günstiger</span>'); }
    if (hatPreis && n.teurer) { marken.push('<span class="mehr">' + n.teurer + ' gleich oder teurer</span>'); }
    if (n.nurStueck) { marken.push('<span>' + n.nurStueck + ' ohne Bedarf, Direktvergleich je VPE</span>'); }
    if (hatPreis && n.ohnePreis) { marken.push('<span>' + n.ohnePreis + ' ohne Preis</span>'); }
    if (n.ohne) { marken.push('<span>' + n.ohne + ' nicht zugeordnet</span>'); }
    if (marken.length) { html += '<div class="af-kennzahlen">' + marken.join('') + '</div>'; }

    // ⚠️⚠️ Solange basis === 'liste' sind es Listenpreise. Das muss dastehen — sonst
    // rechnet ein B2B-Kunde mit Zahlen, die für ihn zu hoch sind, und wir wirken
    // teurer als wir sind. Seit 24.09.2026 HERVORGEHOBEN — rote Flaeche direkt unter
    // der Summe, mit eigenem Knopf —, weil ein graues Band neben den grossen Zahlen
    // uebersehen wurde. Gleicher Wortlaut wie im PDF.
    // ⚠️ Auch beim Mengenpreis: Er rechnet ebenfalls mit Listenpreisen.
    if ((hatPreis || mp.anzahl) && a.basis === 'liste') {
      html += '<div class="af-listenpreis" role="note">'
        + '<span class="af-listenpreis-zeichen" aria-hidden="true">i</span>'
        + '<p><b>Du siehst Listenpreise.</b> Mit deinen Konditionen kann unser Preis tiefer liegen.</p>'
        + '<a class="af-knopf weiss klein" href="/account/login">Anmelden</a></div>';
    }

    // ⭐ Der Rechenweg, zugeklappt. Er muss vollstaendig dastehen — wer wechseln
    // will, rechnet nach —, aber er ist nicht das Erste, was man lesen will.
    if (hatPreis || mp.anzahl) {
      var weg = [];
      if (hatPreis) {
        weg.push('Verglichen wird je Stück (bzw. Meter)'
          + (einheit === 'gebinde'
              ? '. Deine Gebindepreise haben wir durch unsere VPE geteilt — ist dein Gebinde anders gross, '
                + 'bitte Stückpreise angeben.'
              : '.'));
      }
      if (hatMenge) {
        weg.push(zeitraum === 'jahr'
          ? 'Dein Bedarf gilt als Jahresbedarf. In der Spalte „Menge“ steht je eine VPE — '
            + 'trag ein, was du jetzt bestellen möchtest.'
          : 'Dein Bedarf gilt für eine Bestellung' + (faktor > 1 ? ', die grossen Zahlen gelten für '
            + faktor + ' Bestellungen' : '') + '. Bestellt wird in ganzen VPE; die Menge in der '
            + 'Zeile ist entsprechend aufgerundet.');
      }
      if (hatPreis && hatMenge) {
        weg.push('„Ersparnis gesamter Bedarf“ rechnet alle Positionen mit Preis und Bedarf — auch '
          + 'die, die bei uns gleich teuer oder teurer sind. „Nur günstigere Produkte“ zählt nur '
          + 'die Positionen, die bei uns günstiger sind.');
      }
      if (n.nurStueck) {
        weg.push('Wo kein Bedarf steht, vergleichen wir automatisch je eine Verkaufseinheit (VPE) von '
          + 'jedem Artikel — eine Menge, die du bestellen kannst. Dieser Direktvergleich ist eine '
          + 'eigene Summe und steckt nicht in der Ersparnis auf deinen Bedarf.');
      }
      if (mp.anzahl) {
        weg.push('Wo kein Preis steht, zeigen wir den Mengenpreis: dein Bedarf, aufgerundet auf ganze '
          + 'VPE, mal unserem Preis je VPE — das, was du bei uns bezahlen würdest.');
      }
      if (hatPreis) { weg.push('„Bisher“ sind deine Angaben aus der Liste.'); }

      html += '<details class="af-rechenweg"><summary>So haben wir gerechnet</summary>'
        + '<ul><li>' + weg.join('</li><li>') + '</li></ul></details>';
    }

    return html;
  }

  // ── Warenkorb und Anfrage ───────────────────────────────────────────────

  wurzel.addEventListener('click', function (ev) {
    // ⭐ Eine Zeile: mit der Menge aus IHRER Zeile, nicht pauschal 1.
    var korb = ev.target.closest('[data-af-korb]');
    if (korb) {
      var zeile = korb.closest('.af-zeile');
      inDenKorb([{ id: korb.dataset.afKorb, menge: mengeIn(zeile) }], korb, function () {
        // ⚠️ Haken weg, damit der Sammelknopf diesen Artikel nicht noch einmal legt.
        var k = zeile && zeile.querySelector('input[data-af-wahl]');
        if (k && k.checked) {
          k.checked = false;
          k.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      return;
    }

    var fav = ev.target.closest('[data-af-fav]');
    if (fav) {
      var favId = fav.dataset.afFav;
      inDieFavoriten([{ id: favId, menge: mengeIn(fav.closest('.af-zeile')), karte: karten[favId] || null }], fav);
      return;
    }

    var pdfKnopf = ev.target.closest('[data-af-pdf]');
    if (pdfKnopf) { pdfLaden(pdfKnopf); return; }

    // Aus der Auswertung zurueck an den Anfang des Listenwegs. Die eingelesene
    // Liste bleibt stehen — wer nur eine Zahl korrigieren will, faengt nicht neu an.
    if (ev.target.closest('[data-af-neu]')) {
      zeigen('ablegen');
      var auf = wurzel.querySelector('.af-liste-auf');
      if (auf) { auf.open = true; }
      return;
    }

    // ⭐ Aus der Mehrfachsuche in den Listenweg: dort gibt es Preis und Bedarf.
    var listeAuf = ev.target.closest('[data-af-liste-oeffnen]');
    if (listeAuf) {
      var aufklapp = wurzel.querySelector('.af-liste-auf');
      if (aufklapp) {
        aufklapp.open = true;
        aufklapp.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }

    // ⭐ Mehrere Nummern und Listenweg: alles Angekreuzte auf einmal, mit den eingestellten Mengen.
    var korbWahl = ev.target.closest('[data-af-korb-wahl]');
    if (korbWahl) {
      var posten = gewaehlte();
      if (!posten.length) { fehler('Bitte mindestens einen Artikel ankreuzen.'); return; }
      fehlerWeg();
      inDenKorb(posten, korbWahl);
      return;
    }

    var favWahl = ev.target.closest('[data-af-fav-wahl]');
    if (favWahl) {
      var merken = gewaehlte();
      if (!merken.length) { fehler('Bitte mindestens einen Artikel ankreuzen.'); return; }
      fehlerWeg();
      inDieFavoriten(merken, favWahl);
      return;
    }

    var eine = ev.target.closest('[data-af-anfrage]');
    if (eine) { anfrageZeigen([eine.dataset.afAnfrage]); return; }

    var mehrere = ev.target.closest('[data-af-anfrage-alle]');
    if (mehrere) {
      anfrageZeigen(aufgeloest.filter(function (z) {
        return z.status === 'keine_zuordnung' || z.status === 'nicht_verfuegbar';
      }).map(function (z) { return z.eingabe; }));
      return;
    }

    var zurueck = ev.target.closest('[data-af-zurueck]');
    if (zurueck) { zeigen(zurueck.dataset.afZurueck); }
  });

  /**
   * „Alle auswählen" und das Zurueckspringen des Schalters.
   *
   * ⚠️ Der Schalter bildet den Zustand ab, statt ihn nur zu setzen: Wer einen
   * Artikel wieder abwaehlt, darf nicht weiter „Alle ausgewaehlt" lesen.
   */
  /**
   * „Anzahl Bestellungen" gibt es nur beim Einkaufsbedarf. Beim Jahresbedarf
   * waere das Feld eine Frage ohne Sinn — und ein stehengebliebener Wert 4 wuerde
   * einen Jahresbedarf still vervierfachen, wenn der Server ihn nicht ohnehin
   * ignorierte.
   */
  function haeufigkeitZeigen() {
    var feld = el('af-oft');
    var jahr = wurzel.querySelector('input[name=af-zeitraum][value=jahr]');
    if (feld) { feld.hidden = !!(jahr && jahr.checked); }
  }
  haeufigkeitZeigen();

  wurzel.addEventListener('change', function (ev) {
    // ⚠️ VOR dem Ausstieg unten: Der Zeitraum sitzt im Spaltenschritt, wo es
    // noch keine Auswahlkaestchen gibt.
    if (ev.target.name === 'af-zeitraum') { haeufigkeitZeigen(); return; }

    var alleSchalter = ev.target.closest('[data-af-alle]');
    var kaesten = wurzel.querySelectorAll('input[data-af-wahl]');
    if (!kaesten.length) { return; }

    if (alleSchalter) {
      kaesten.forEach(function (k) { k.checked = alleSchalter.checked; });
      zaehlerAktualisieren();
      return;
    }

    if (ev.target.closest('[data-af-wahl]')) {
      var schalter = wurzel.querySelector('[data-af-alle]');
      if (schalter) {
        schalter.checked = Array.prototype.every.call(kaesten, function (k) { return k.checked; });
      }
      zaehlerAktualisieren();
    }
  });

  /**
   * ⚠️ /cart/add.js ist der EINZIGE massgebliche Verfügbarkeitstest. Der Index kennt
   * den Bestand von heute Nacht; was dort „verfügbar" heisst, kann längst weg sein —
   * und umgekehrt. Deshalb wird hier nichts vorab gesperrt, sondern die Antwort des
   * Warenkorbs ausgewertet.
   */
  /**
   * Rueckmeldung am Knopf — fuer Textknoepfe UND Symbolknoepfe.
   *
   * ⚠️ Ein Symbolknopf (.af-sym) hat keinen Text, den man austauschen koennte;
   * „✓ im Warenkorb" wuerde das Sinnbild ersetzen und den Knopf aufblaehen,
   * bis die Zeile umbricht. Er wechselt stattdessen seine Klasse:
   * laeuft → fertig. Gibt null zurueck, wenn es ein Symbolknopf ist.
   */
  function knopfLaeuft(knopf, text) {
    knopf.disabled = true;
    if (knopf.classList.contains('af-sym')) { knopf.classList.add('laeuft'); return null; }
    var alt = knopf.textContent;
    knopf.textContent = text;
    return alt;
  }

  /** @param bleibt  Symbolknopf behaelt „fertig" (das gefuellte Herz). */
  function knopfFertig(knopf, alt, text, bleibt) {
    if (alt === null) {
      knopf.classList.remove('laeuft');
      knopf.classList.add('fertig');
    } else {
      knopf.textContent = text;
    }
    setTimeout(function () {
      knopf.disabled = false;
      if (alt === null) { if (!bleibt) { knopf.classList.remove('fertig'); } }
      else { knopf.textContent = alt; }
    }, 2500);
  }

  function knopfZurueck(knopf, alt) {
    knopf.disabled = false;
    if (alt === null) { knopf.classList.remove('laeuft'); } else { knopf.textContent = alt; }
  }

  /** @param danach  Optional, laeuft nur nach Erfolg. */
  function inDenKorb(posten, knopf, danach) {
    if (!posten.length) { return; }
    var alt = knopfLaeuft(knopf, 'wird hinzugefügt …');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: posten.map(function (p) { return { id: p.id, quantity: p.menge }; }) })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { throw new Error(j.description || j.message || 'Der Warenkorb hat abgelehnt.'); }
        return j;
      });
    }).then(function () {
      knopfFertig(knopf, alt, '✓ im Warenkorb', false);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      if (danach) { danach(); }
    }).catch(function (e) {
      knopfZurueck(knopf, alt);
      fehler(e.message || 'Das hat der Warenkorb nicht angenommen.');
    });
  }

  /**
   * Ausgewaehlte Artikel merken.
   *
   * ⚠️⚠️ Geht ueber window.Favorites.add() aus assets/favorites.js — NICHT ueber
   * einen eigenen Aufruf der Favoriten-API. Jenes Modul fuehrt den angemeldeten
   * Zustand, die Listenwahl, den Gastspeicher im Browser und die Herz-Knoepfe der
   * ganzen Seite. Ein zweiter Schreibweg daneben wuerde all das umgehen: Der
   * Artikel laege in der Liste, das Herz auf der Produktseite bliebe leer.
   *
   * ⚠️ In der Vorschauseite gibt es window.Favorites NICHT — dort laeuft nur
   * artikelfinder.js. Deshalb der ausdrueckliche Hinweis statt eines stummen
   * Fehlers: Sonst sieht es bei der Abnahme nach einem Bug aus, wo nur die
   * Umgebung fehlt.
   */
  function inDieFavoriten(posten, knopf) {
    if (!posten.length) { return; }

    if (!window.Favorites || typeof window.Favorites.add !== 'function') {
      fehler('Die Favoriten stehen nur im Shop zur Verfügung — diese Vorschauseite '
        + 'lädt favorites.js nicht mit.');
      return;
    }

    var alt = knopfLaeuft(knopf, 'wird gemerkt …');

    // ⚠️ Die Standardliste EINMAL bestimmen, nicht je Artikel. Sonst landeten bei
    // zwanzig Artikeln zwanzig Abfragen auf derselben Liste — und legte jemand
    // waehrenddessen eine neue an, verteilten sie sich auf zwei.
    var liste = typeof window.Favorites.defaultList === 'function'
      ? window.Favorites.defaultList() : null;
    var listenId = liste && liste.id ? liste.id : null;

    // ⚠️ Nacheinander, nicht alle gleichzeitig. window.Favorites.add() ruft nach
    // jedem Schreiben load() und damit die Liste neu ab; zwanzig parallele Laeufe
    // wuerden einander die Antwort ueberschreiben.
    var i = 0;
    var fehlgeschlagen = 0;

    function weiter() {
      if (i >= posten.length) {
        if (fehlgeschlagen) {
          fehler(fehlgeschlagen + ' Artikel konnten nicht gemerkt werden.');
        }
        if (typeof window.Favorites.syncHearts === 'function') { window.Favorites.syncHearts(); }

        // Nichts gemerkt: kein Haken, auch nicht am Symbolknopf.
        if (fehlgeschlagen === posten.length) { knopfZurueck(knopf, alt); return; }

        knopfFertig(knopf, alt, fehlgeschlagen
          ? '✓ ' + (posten.length - fehlgeschlagen) + ' von ' + posten.length + ' gemerkt'
          : '✓ gemerkt', true);
        return;
      }

      var dieser = posten[i];
      var t = dieser.karte;
      i++;

      if (!t || !t.sku) { fehlgeschlagen++; weiter(); return; }

      // ⚠️ In Promise.resolve gewickelt: add() gibt im Gastfall load() zurueck und
      // im Sonderfall „schon gemerkt" ein Promise.resolve() — verliesse sich der
      // Ablauf darauf, dass IMMER ein Promise kommt, bliebe die Schleife beim
      // ersten Rueckgabewert ohne .then stumm stehen, mitten in der Liste.
      Promise.resolve(window.Favorites.add({
        sku: t.sku,
        handle: t.handle || '',
        variantId: parseInt(t.id, 10) || 0,
        title: t.title || null,
        variantTitle: t.unterschied || null,
        imageUrl: t.img || null,
        category: t.cat || null,
        qty: dieser.menge
      }, listenId)).then(weiter).catch(function (e) {
        fehlgeschlagen++;
        if (window.console) { console.warn('[Artikelfinder] Favorit fehlgeschlagen', e); }
        weiter();
      });
    }

    weiter();
  }

  function anfrageZeigen(nummern) {
    if (!nummern.length) { return; }
    el('af-anfrage').hidden = false;
    el('af-anfrage-zahl').textContent = nummern.length;
    el('af-anfrage').dataset.nummern = JSON.stringify(nummern);
    el('af-anfrage').scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  el('af-senden').addEventListener('click', function () {
    var email = el('af-email').value.trim();
    if (!email || email.indexOf('@') < 1) {
      el('af-anfrage-antwort').innerHTML = '<div class="af-band warn">Bitte eine gültige E-Mail-Adresse angeben.</div>';
      return;
    }

    var nummern = [];
    try { nummern = JSON.parse(el('af-anfrage').dataset.nummern || '[]'); } catch (e) {}

    var knopf = this;
    knopf.disabled = true;

    // ⚠️ Es gehen NUR die Nummern und die Kontaktdaten hinaus — keine Preise aus der
    // Liste des Kunden. Was er heute zahlt, geht uns erst etwas an, wenn er es sagt.
    api('/api/b2b/finder/anfrage', {
      email: email,
      firma: el('af-firma').value.trim(),
      bemerkung: el('af-bemerkung').value.trim(),
      nummern: nummern
    }).then(function () {
      el('af-anfrage-antwort').innerHTML = '<div class="af-band gut">Danke — wir sehen uns '
        + 'die Nummern an und melden uns.</div>';
      knopf.hidden = true;
    }).catch(function () {
      knopf.disabled = false;
      el('af-anfrage-antwort').innerHTML = '<div class="af-band warn">Das Absenden hat gerade '
        + 'nicht geklappt. Bitte in einem Moment erneut versuchen.</div>';
    });
  });

  /**
   * Vorbelegung aus der Adresse (Aufgabe #59, 19.10.2026): Die Scan-Seite schickt die
   * gescannten FREMDEN Nummern mit „Vergleichen" hierher — /pages/artikelfinder?vergleich=A,B,C.
   * Eine Nummer → Einzelsuche, mehrere → Mehrfachsuche; derselbe Weg wie von Hand getippt.
   *
   * ⚠️ Am ENDE des Skripts, damit alle Zustaende oben schon belegt sind.
   */
  (function vorbelegen() {
    var roh = null;
    try { roh = new URLSearchParams(window.location.search).get('vergleich'); } catch (e) { roh = null; }
    var nummern = nummernAusText(roh || '').slice(0, MAX_ZEILEN);
    var feld = el('af-suche');
    if (!nummern.length || !feld) { return; }
    feld.value = nummern.join(', ');
    feld.dispatchEvent(new Event('input', { bubbles: true }));
    if (nummern.length >= 2 && mehrfachKnopf) { mehrfachKnopf.click(); }
    feld.scrollIntoView({ block: 'start' });
  })();
})();
